import { GroupActionModal, type GroupActionModalProps } from './GroupActionModal';

type DeactivateGroupModalProps = Omit<GroupActionModalProps, 'mode' | 'onClose'> & {
    onCancel: () => void;
};

export const DeactivateGroupModal = ({ onCancel, ...props }: DeactivateGroupModalProps) => (
    <GroupActionModal
        {...props}
        mode={'deactivate'}
        onClose={onCancel}
    />
);
